import React from "react";
import Moment from "react-moment";
import Timeline from "./Timeline";

const MyPostulationHit = ({ postulation }) => {
  return (
    <tr>
      <td>
        {postulation.course.title}
      </td>
      <td className="align-middle">
        <Moment format="DD/MM/YYYY HH:mm">{postulation.created_at}</Moment>
      </td>
      <td>
        {postulation.timeline && postulation.timeline.length > 0 ? (
          <Timeline steps={postulation.timeline} />
        ) : (
          <div className="alert alert-warning">No hay información de la línea de tiempo.</div>
        )}
      </td>
    </tr>
  );
};

export default MyPostulationHit;
